import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Typography } from '@mui/material';
import StyledBox from './styles';

export default function DetectionSnackbarContent(props: {
  title: string;
}) {
  const { title } = props;

  return (
    <StyledBox>
      <Box className="content">
        <Box className="iconWrapper">
          <InfoOutlinedIcon sx={{ fontSize: 18 }} />
        </Box>
        <Typography variant="body2" className="text">
          {title}
        </Typography>
      </Box>
    </StyledBox>
  );
}
